import React, { useState, useContext } from 'react';
import { EyeIcon, EyeOffIcon } from '@heroicons/react/outline'; 
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from './App';

function Signup() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    // const [username, setName] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { setAuth } = useContext(AuthContext);

    const handleSignup = (e) => {
        e.preventDefault();
        axios.post('https://api.finaloffers.fyi/auth/signup', {email, password })
            .then(response => {
                console.log("Signup successful", response.data);
                localStorage.setItem('isLoggedIn', 'true');
                localStorage.setItem('user', response.data.userId);
                localStorage.setItem('email', email); // Store email in localStorage
                setAuth({ isLoggedIn: true, user: response.data.userId, email: email  });
                navigate('/');
            })
            .catch(error => {
                console.error("Signup failed", error.response.data);
                setError(error.response.data.message);
            });
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className='flex justify-center items-center mt-10'>
            <div className='border border-black rounded shadow-solid h-80'>
            <div className='justify-center text-center w-full mt-4 font-bold text-lg'>Sign Up</div>
 
        <form  className='w-96 max-w-xs p-6 rounded' onSubmit={handleSignup}>
            {/* <input
                type="text"
                placeholder="Name"
                value={username}
                onChange={(e) => setName(e.target.value)}
                required
                className='items-center w-full rounded h-8 text-sm focus:ring-0 border-black focus:border-black'
            /> */}
            <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                // className={`items-center w-full rounded mt-4 h-8 text-sm focus:ring-0 border-black focus:border-black pr-10 `}
                className='items-center w-full rounded h-8 text-sm focus:ring-0 border-black focus:border-black'
            />
            <div className="relative">
                <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    className={`items-center w-full rounded mt-4 h-8 text-sm focus:ring-0 border-black focus:border-black pr-10 `}

                />
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pt-4">
                    {showPassword ? (
                        <EyeOffIcon className="h-5 w-5 text-gray-500 cursor-pointer" onClick={togglePasswordVisibility} />
                    ) : (
                        <EyeIcon className="h-5 w-5 text-gray-500 cursor-pointer" onClick={togglePasswordVisibility} />
                    )}
                </div>
            </div>
            <button className='items-center w-full bg-black text-white rounded mt-12 h-8 text-sm cursor-pointer' type="submit">
                Sign Up
            </button>
            {error && <div style={{ color: 'red' }}>{error}</div>}
            <div>
                {error === "Email already exists. Try logging in or resetting your password." && (
                    <div>
                        <button onClick={() => navigate('/login')}>Login</button>
                        <button onClick={() => navigate('/forgot-password')}>Forgot Password</button>
                    </div>
                )}
            </div>
        </form>
        </div>
        </div>
    );
}

export default Signup;

// ===================================================================================================

// import React, { useState, useContext } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { AuthContext } from './App';

// function Signup() {
//     const [email, setEmail] = useState('');
//     const [password, setPassword] = useState('');
//     const [username, setName] = useState('');
//     const [error, setError] = useState('');
//     const navigate = useNavigate();
//     const { setAuth } = useContext(AuthContext);

//     const handleSignup = (e) => {
//         e.preventDefault();
//         axios.post('http://localhost:5000/auth/signup', { username, email, password })
//             .then(response => {
//                 console.log("Signup successful", response.data);
//                 setAuth({ isLoggedIn: true, user: response.data.userId });
//                 navigate('/');
//             })
//             .catch(error => {
//                 console.error("Signup failed", error.response.data);
//                 setError(error.response.data.message);
//             });
//     };

//     return (
//         <form onSubmit={handleSignup}>
//             <input
//                 type="text"
//                 placeholder="Name"
//                 value={username}
//                 onChange={(e) => setName(e.target.value)}
//                 required
//             />
//             <input
//                 type="email"
//                 placeholder="Email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//             />
//             <input
//                 type="password"
//                 placeholder="Password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//             />
//             <button type="submit">Sign Up</button>
//             {error && <div style={{ color: 'red' }}>{error}</div>}
//             <div>
//                 {error === "Email already exists. Try logging in or resetting your password." && (
//                     <div>
//                         <button onClick={() => navigate('/login')}>Login</button>
//                         <button onClick={() => navigate('/forgot-password')}>Forgot Password</button>
//                     </div>
//                 )}
//             </div>
//         </form>
//     );
// }

// export default Signup;

// ===============================================================================================

// import React, { useState, useContext } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { AuthContext } from './App';

// function Signup() {
//     const [email, setEmail] = useState('');
//     const [password, setPassword] = useState('');
//     const [username, setName] = useState('');
//     const navigate = useNavigate();
//     const { setAuth } = useContext(AuthContext);

//     const handleSignup = async (e) => {
//         e.preventDefault();
//         axios.post('http://localhost:5000/auth/signup', { username, email, password })
//                 .then(response => {
//                     console.log("Signup successful", response.data);
//                     setAuth({ isLoggedIn: true, user: response.data.userId });
//                     navigate('/');
//                 })
//                 .catch(error => {
//                     console.error("Signup failed", error.response.data);
//                 });
//         // e.preventDefault();
//         // console.log({email, password, name});
//         // try {
            
//         //     const response = await axios.post('http://localhost:5000/auth/signup', { email, password, name });
//         //     console.log("User created successfully!");
//         //     setAuth({ isLoggedIn: true, user: response.data.userId });
//         //     navigate('/');
//         // } catch (error) {
//         //     console.error(error);
//         // }

        
//     };

//     return (
//         <form onSubmit={handleSignup}>
//             <input
//                 type="text"
//                 placeholder="Name"
//                 value={username}
//                 onChange={(e) => setName(e.target.value)}
//                 required
//             />
//             <input
//                 type="email"
//                 placeholder="Email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 required
//             />
//             <input
//                 type="password"
//                 placeholder="Password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 required
//             />
//             <button type="submit">Sign Up</button>
//         </form>
//     );
// }

// export default Signup;
